export default __webpack_public_path__ + "static/media/Counseller_Transfer.3de7ad18.svg";